import styled from "styled-components";
import { device } from "../breakpoints";

export const HeroVideoContainer = styled.div`
  width: 540px;
  height: 480px;
  border-radius: 24px;
  overflow: hidden;
  margin-left: 90px;
  flex-shrink: 0;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 24px;
  }
  @media ${device.mobile} {
    width: 100%;
    height: 300px;
    margin-left: 0;
    border-radius: 12px;
    > video {
      border-radius: 12px;
    }
  }
`;
